import React from 'react';

function CustomerJobs() {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Service Jobs</h1>
        <p className="subtitle">Track your service requests</p>
      </div>
      <div className="empty-state">
        <p>Service jobs tracking coming soon!</p>
      </div>
    </div>
  );
}

export default CustomerJobs;
